<template>
  <div class="logo-banner">
    <label v-if="text" class="logo-banner-text">{{ text }}</label>
    <div class="logo-banner-content">
      <div
        v-for="(item, index) in listOfIcons"
        :key="`${index}-${item}`"
        :title="item"
        class="logo-banner-image"
      >
        <CustomIcon :name="item" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomIcon from "./CustomIcon.vue";
export default {
  name: "logo-banner",
  props: {
    text: String,
    listOfIcons: [],
  },
  components: { CustomIcon },
};
</script>
